'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import { Fancybox } from "@fancyapps/ui";

EwSiteApp.controller('gasConnectCalcCtrl', ['$scope', '$filter', function ($scope, $filter) {
		$scope.displayStatus = 0;
		$scope.showResults = false;
		$scope.connection_types = tariffs_data.tarrifs_types;
		$scope.connection_type = 'tariff_type_1';
		$scope.distance = '';

		var regia_domain = tariffs_data.regia_domain;
		var regia_params = tariffs_data.regia;
		var distance_url = tariffs_data.distance_url;
		var translations = tariffs_data.translations;
		//var self = $(this);
		this.cache = {};

		var self = this;


		$('body').on('click', '.municipality', function () {
			openRegiaByMunicipality($(this).data('key'));
		});

		$("#distance_by_gps a").click(function (e) {
			e.preventDefault();
			openRegiaByGps();
		});

		this.getT = function (msg) {
			if (typeof (translations[msg]) === 'undefined') {
				return '*' + msg + '*';
			}
			return translations[msg];
		};

		$scope.setConnectionType = function (type) {
			$scope.connection_type = type.id;
			if ($scope.connection_type === 'tariff_type_1') {
				$scope.urlParams.tipas = '1';
			}
			if ($scope.connection_type === 'tariff_type_2') {
				$scope.urlParams.tipas = '2';
			}
			$scope.situationTitle = type.title;
			$scope.setDisplayStatus(1);
		};

		$scope.validateInput = function (event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		};

		$scope.getIconPath = function (form) {
			return form.icon;
		};


		$scope.urlParams = {
			tipas: '',
			atstumas: ''
		};

		var searchObj = {};
		var queryString = '';


		function parseSearch() {
			queryString = window.location.search;
			let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('_');
			for (var i = 0; i < pairs.length; i++) {
				let pair = pairs[i].split('-');
				let name = decodeURIComponent(pair[0]);
				searchObj[name] = decodeURIComponent(pair[1] || '');

			}
		}
		parseSearch();

		function setQueryData() {
			queryString = '?' + formatHistoryQuery();
			history.pushState("", document.title, window.location.pathname + queryString);
		}

		function formatHistoryQuery() {
			let el = [];
			for (var i in $scope.urlParams) {
				if (typeof ($scope.urlParams[i]) !== 'undefined' && $scope.urlParams[i] !== '') {
					el.push(i + '-' + $scope.urlParams[i]);
				}
			}

			return el.join('_');
		}

		$scope.$watch("urlParams.tipas", function () {
			setQueryData();
		});

		$scope.$watch("urlParams.atstumas", function () {
			setQueryData();
		});

		$scope.setDisplayStatus = function (status) {
			if (status < 1) {
				$scope.situationTitle = "";
			}
			if (status == 0) {
				$scope.urlParams.tipas = '';
				$scope.urlParams.atstumas = '';
			}
			if (status == 1) {
				$scope.urlParams.atstumas = '';
			}

			$scope.displayStatus = status;

		};

		function openRegiaByMunicipality(key) {
			var municipality = key;
			if (!municipality) {
				return false;
			}

			var url = regia_domain + (regia_params.municipality_path.replace('%MUNI%', municipality));

			// Close the current Fancybox if one is open
			const instance = Fancybox.getInstance();
			if (instance) {
				instance.close();
			}

			openRegiaIframe(url);
		}

		function openRegiaIframe(url) {
			showLoading('loading_regia_map');
			Fancybox.show([{
					type: 'iframe',
					src: url,
					width: '100%',
					autoSize: false,
					autoHeight: true,
					autoWidth: false,
					fitToView: true,
					closeButton: false,
					on: {
						init: (fancybox) => {
							hideLoading('loading_regia_map');
							document.body.style.overflowY = "hidden";
							document.body.style.position = "fixed";
						},
						destroy: (fancybox) => {
							hideLoading('loading_regia_map');
							document.body.style.overflowY = "";
							document.body.style.position = "";
						}
					}
				}]);

		}

		function receiveRegiaData(event) {
			const instance = Fancybox.getInstance();
			if (instance) {
				instance.close();
			}

			if (event.origin !== regia_domain) {
				return;
			}
			if (event.data) {
				var result = event.data.data;
				showDistance(result.x, result.y);
			}
		}

		window.addEventListener('message', receiveRegiaData, false);
		function showDistance(x, y, type) {
			if (typeof distance_url !== 'string') {
				return false;
			}
			type = typeof type == 'undefined' ? '' : type;
			showLoading('loading_text');
			$.ajax({
				type: 'GET',
				url: distance_url,
				data: {x: x, y: y, type: type},
				success: function (resp) {
//				console.log('success');
					if (resp.success) {
						$('#distance').val(resp.distance).trigger("keyup");

					} else {
						alert(resp.message);
					}
				},
				error: function (xhr, ajaxOptions, thrownError) {
//				console.log('error');
					alert('Distance request error: ' + xhr.status + ' ' + thrownError);
				},
				complete: function () {
					hideLoading('loading_text');
					hideLoading('loading_regia_map');
//				console.log('complete');
				}
			});
		}


		function openRegiaByGps() {
			if (!('geolocation' in navigator)) {
				alert('Geolocation is not supported by this browser');
				return false;
			}

			navigator.geolocation.getCurrentPosition(
					function (pos) {
						self.cache.latitude = pos.coords.latitude;
						self.cache.longitude = pos.coords.longitude;
						showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
					},
					function (error) {
						if (typeof (self.cache.latitude) !== 'undefined' && typeof (self.cache.longitude) !== 'undefined') {
							showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
						} else {
							alert('Neperduotos koordinatės skaičiuoklei, peržiūrėkite įrenginio nustatymus');
						}

					}
			);
		}

		function showLoading(text_id) {
			var id = 'calc-loading';
			if ($('#' + id).length) {
				return;
			}
			$('body').append('<div id="' + id + '" class="' + text_id + '"><div>' + self.getT(text_id) + '</div></div>');
		}

		function hideLoading(text_id) {
			text_id = (typeof text_id === 'string') ? '.' + text_id : '';
			$('#calc-loading' + text_id).remove();
		}

		$scope.calculateGasConnection = function () {
			$scope.setDisplayStatus(2);
			if (typeof tariffs_data !== 'undefined') {
//			var connectionType = $scope.connection_type;
				var fixed_rate = parseFloat(tariffs_data.tariffs[$scope.connection_type + '_fixed_rate']);
				var variable_rate = parseFloat(tariffs_data.tariffs[$scope.connection_type + '_variable_rate']);
				var variable_rate150 = parseFloat(tariffs_data.tariffs[$scope.connection_type + '_variable_rate150']);
				//		var vat_percent = parseFloat(tariffs_data.vat_percent);
				var distance = parseFloat($('#distance').val().replace(',', '.'));
				$scope.urlParams.atstumas = distance;
				$scope.distance = distance;
				if (!isNaN(distance)) {
					if (distance > 150) {
						var variable_rate_distance = ((variable_rate * 150) + (variable_rate150 * (distance - 150)));
					} else {
						var variable_rate_distance = (variable_rate * distance);
					}

					var price_without_vat = (fixed_rate + variable_rate_distance);
					var price_with_vat = (price_without_vat * (1 + tariffs_data.vat_percent * 0.01));

					$('#connection_price_holder').text(fixed_rate.toFixed(2).replace('.', ','));
					$('#connection_price_without_vat_holder').text(price_without_vat.toFixed(2).replace('.', ','));
					$('#connection_price_with_vat_holder').text(price_with_vat.toFixed(2).replace('.', ','));
					$('#variable_rate').text(variable_rate_distance.toFixed(2).replace('.', ','));
//				$price_text.toggle(tariffs_data.price_max_boundry >=0 && price_with_vat >= tariffs_data.price_max_boundry);
				} else {
					// show error or smth
					$('#connection_price_holder').text('0,00');
					$('#connection_price_with_vat_holder').text('0,00');
					$('#connection_price_without_vat_holder').text('0,00');
//				$price_text.hide();
				}
			}
		};

		$scope.init = function () {
			if (typeof (searchObj.tipas) !== 'undefined') {
				if (searchObj.tipas === '1') {
					let q = $filter('filter')($scope.connection_types, {id: 'tariff_type_1'}, true);
					if (typeof (q[0]) !== 'undefined') {
						$scope.setConnectionType(q[0]);
					}
				} else if (searchObj.tipas === '2') {
					let q = $filter('filter')($scope.connection_types, {id: 'tariff_type_2'}, true);
					if (typeof (q[0]) !== 'undefined') {
						$scope.setConnectionType(q[0]);
					}
				}
			}
			if (typeof (searchObj.atstumas) !== 'undefined') {
				$('#distance').val(searchObj.atstumas);
				$scope.calculateGasConnection();
			}

		};

		$scope.init();
	}]);
